<script>
    import f9field from "./f9field";
    import f9select2 from "./f9select2";

    export default {
        components: {
            f9field,
            f9select2
        },
        props: {
            value: Array,
            accordionLabel: {
                type: String,
                default: ""
            },
            accordionSubLabel: {
                type: String,
                default: ""
            },
            canAddPassengers: {
                type: Boolean,
                default: true
            },
            minimumNumberOfPassengersByType: {
                type: Number,
                default: 0
            },
            buildTravelersText: Function,
            onRemove: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                items: this.value
            };
        },
        mounted() {
            while(this.items.length < this.minimumNumberOfPassengersByType) {
                this.items.push(this.defaultAge);
            }
        },
        methods: {
            emitInput() {
                this.$emit("input", this.items);
            },
            addNumberOfPassengers(numberToAdd) {
                if(numberToAdd > 0) {
                    for(var i = 0; i < numberToAdd; i++) {
                        this.items.push(this.defaultAge)
                    }
                } else {
                    for(var i = 0; i > numberToAdd; i--) {
                        this.onRemove();
                        this.items.pop();
                    }
                }

                this.buildTravelersText(numberToAdd, this.accordionLabel);
                this.emitInput();
            },
            createRange(start, end) {
                return Array(end - start + 1).fill().map((_, index) => (start + index).toString());
            }
        },
        computed: {
            defaultAge() {
                switch(this.accordionLabel) {
                    case "Adults":
                        return "35";
                    default:
                        return "0";
                }
            },
            inputLabel() {
                switch(this.accordionLabel) {
                    case "Adults":
                        return "Adult";
                    case "Lap Infants":
                        return "Lap Infant";
                    case "Children":
                        return "Child";
                }
            },
            inputOptions() {
                switch(this.accordionLabel) {
                    case "Adults":
                        var adultAges = this.createRange(15, 99);
                        adultAges.push("100+");
                        return adultAges;
                    case "Lap Infants":
                        return this.createRange(0, 1);
                    case "Children":
                        return this.createRange(0, 14);
                }
            }
        }
    }
</script>

<template>
    <div class="passenger-picker-accordion">
        <div class="tab" :aria-expanded="items.length > 0 ? 'true' : 'false'">
            <div>
                <p class="pax-type">{{ accordionLabel }}</p>
                <p class="pax-age">{{ accordionSubLabel }}</p>
            </div>
            <div class="controls">
                <img 
                    :alt="'Remove' + accordionLabel" 
                    :class="{ disabled: items.length <= minimumNumberOfPassengersByType }"
                    :aria-disabled="items.length <= minimumNumberOfPassengersByType ? 'true' : 'false'"
                    src="//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/minus-active.svg"
                    role="button" 
                    :tabindex="items.length <= minimumNumberOfPassengersByType ? '-1' : '0'"
                    @click="minimumNumberOfPassengersByType < items.length ? addNumberOfPassengers(-1) : null"
                    @keypress.enter="minimumNumberOfPassengersByType < items.length ? addNumberOfPassengers(-1) : null"
                /> 
                <p class="count">{{ items.length }}</p>
                <img 
                    :alt="'Add' + accordionLabel" 
                    :class="{ disabled: !canAddPassengers }"
                    :aria-disabled="!canAddPassengers ? 'true' : 'false'"
                    src="//flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/plus-active.svg"
                    role="button" 
                    tabindex="0"
                    @click="canAddPassengers ? addNumberOfPassengers(1) : null"
                    @keypress.enter="canAddPassengers ? addNumberOfPassengers(1) : null"
                /> 
            </div>
        </div>
        <div class="tab-inputs" v-show="items.length > 0">
            <f9field 
                v-for="(input, index) in items" 
                :key="inputLabel + (index + 1)"
                :label="inputLabel + ' ' + (index + 1) + ' Age'"
            >
                <f9select2 
                    @input="emitInput"
                    :name="accordionLabel"
                    :value="accordionLabel === 'Adults' ? 35 : 0"
                    width="86px"
                    v-model="items[index]"
                >
                    <option 
                        v-for="(age, index) in inputOptions"
                        :key="index"
                        :value="age === '100+' ? '100' : age"
                    >{{ age }}</option>
                </f9select2>
            </f9field>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .passenger-picker-accordion {
        background-color: @white;
        padding-bottom: 12px;
        line-height: normal;
        letter-spacing: normal;

        .tab {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0 14px;
            align-items: center;
            height: 44px;
            background-color: @frontier-gray-xxlighter;

            .pax-type {
                color: @frontier-gray-xxdark;
                font-size: 14px;
                font-weight: 600;
                margin: 0;
            }

            .pax-age {
                color: @ibe-text--light-bluegray;
                font-size: 11px;
                margin: 0;
            }

            .controls {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100px;

                .disabled {
                    opacity: 0.3;
                }

                img:not(.disabled) {
                    cursor: pointer;
                }

                .count {
                    font-size: 12px;
                    margin: 0;
                }
            }
        }

        .tab-inputs {
            padding: 0 14px;

            @{deep} .slider-field {
                width: 86px;

                select {
                    @media @Firefox {
                        padding-left: 8px;
                    }
                }

                .slider-label {
                    padding-bottom: 2px;
                    width: 100px;
                    font-size: 11px;
                }
            }

            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;

            &::after {
                content: '';
                width: 86px;
            }
        }
    }

    @media @tablet {
        .passenger-picker-accordion {
            padding-bottom: 14px;

            .tab {
                .pax-type {
                    font-size: 12px;
                }

                .controls {
                    width: 92px;
                }
            }

            .tab-inputs {
                @{deep} .slider-field {
                    .slider-label {
                        padding-bottom: 4px;
                    }
                }
            }
        }
    }
</style>